import { DexEntityTypeEnum, DexEntityTypeEnumType, DexRegionEnumType } from '@mark43/cad-api';

export function shouldShowImageIndicator(
    dexEntityType: DexEntityTypeEnumType,
    dexRegion?: DexRegionEnumType,
    inquiryTypeCode?: string
): boolean {
    // AZ_ACJIS: Show Image Indicator only for Person DL (Driver License) queries
    if (dexRegion === 'AZ_ACJIS' && dexEntityType === DexEntityTypeEnum.PERSON.name) {
        return inquiryTypeCode === 'DL';
    }
    
    // For other regions, show Image Indicator field by default
    return true;
}
